import { Dialog, DialogFooter } from "@fluentui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import {
  setUsersReportDocumentDialog,
  usersReportDocumentRoutine,
} from "../../store/locations-page/locationsPage";
import { StyledPrimaryButton } from "../../components/styled";
import { FormSpinner } from "../../components/FormSpinner";
import { useSelector } from "../../store/hooks";

export const UsersReportDocumentDialog = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const isLoading = useSelector(
    (s) => s.locationsPage.usersReportDocumentLoadStatus === "loading"
  );
  const usersReportDocumentDialog = useSelector(
    (s) => s.locationsPage.usersReportDocumentDialog
  );
  const usersReportDocument = useSelector(
    (s) => s.locationsPage.usersReportDocument
  );
  const close = () => {
    dispatch(
      setUsersReportDocumentDialog({
        isOpen: false,
        clientId: null,
        locationId: null,
      })
    );
  };

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        showCloseButton: true,
        title: t("ram.locationsReport.label"),
      }}
      onDismiss={close}
    >
      {t("ram.locationsReportDocumentDialogText.label")}
      <DialogFooter>
        {usersReportDocument !== null ? (
          <StyledPrimaryButton
            iconProps={{ iconName: "Download" }}
            text={t("ram.usersReportDocumentDialogDownload.label")}
            onClick={() => {
              window.open(usersReportDocument.url, "_blank");
              close();
            }}
          />
        ) : (
          <StyledPrimaryButton
            iconProps={{ iconName: "TextDocument" }}
            text={t("ram.reportDocumentDialogGenerate.label")}
            onClick={() => {
              dispatch(
                usersReportDocumentRoutine.trigger({
                  clientId: usersReportDocumentDialog.clientId,
                  locationId: usersReportDocumentDialog.locationId,
                })
              );
            }}
            disabled={isLoading}
          />
        )}
      </DialogFooter>
      {isLoading && <FormSpinner />}
    </Dialog>
  );
};
